import React from "react";
import { stringify } from "../../pages/bookings/util";
import { Booking } from "../../types";
import { formatDateToTime12h } from "../../utils/date";

interface Props {
  booking: Booking;
  start: Date;
  end: Date;
  /** Prepend the "8:00 AM - 11:00 AM" line (time-based layouts only). */
  showTime?: boolean;
}

/** Vertical stack of `stringify` lines (compact for EOT, classic layout for other bookings). */
const BookingCardLabel: React.FC<Props> = ({
  booking,
  start,
  end,
  showTime = false,
}) => {
  const isRevised = booking.revisions?.length > 0;

  const lines = stringify(booking)
    .trim()
    .split("\n")
    .map((l) => l.trim())
    .filter(Boolean);

  const timeString = `${formatDateToTime12h(start)} - ${formatDateToTime12h(end)}`;

  return (
    <div
      className={`booking-calendar-event-label${showTime ? " booking-calendar-event-label--time" : ""}`}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 2,
        width: "100%",
        minWidth: 0,
      }}
    >
      {showTime && (
        <span title={timeString} style={{ fontWeight: 700, fontSize: "0.7rem" }}>
          {timeString}
        </span>
      )}

      {isRevised && (
        <span style={{ color: "red", fontWeight: "bold" }}>[REVISED]</span>
      )}
      {booking.is_resubmitted && (
        <span style={{ color: "yellow", fontWeight: "bold" }}>[RESUBMIT]</span>
      )}
      {lines.map((line, idx) => (
        <span key={idx} title={line}>
          {line}
        </span>
      ))}
    </div>
  );
};

export default BookingCardLabel;
